<template>
    <div>

        <div v-html='articleHtml' class='content-wrapper content-text-26' :class=' fontsize == "medium" ? "medium" : "large"' ref='articlContent' @click='handleArtClick'>
        </div>
    </div>
</template>

<script>
import * as client from '@/common/js/client'
export default {
    name: '',
    data() {
        return {
            fontsize: "medium",
            theme: '',
            stats: this.$pageStat(this.propsData.seq, 'body_text')
            // content: `123`}
        }
    },
    props: {
        propsData: {
            type: Object,
            default() {
                return {
                    content: ``
                }
            }
        }
    },
    inject: ['fontsizeCache'],
    computed: {
        articleHtml() {
            let str = this.propsData.content;
            let dom = document.createElement('div');
            dom.innerHTML = str;
            let themeMap = {
                night: '#eeeeee',
                daily: '#262626'
            }
            let fontSizeMap = {
                medium: 16,
                large: 18
            }
            Array.from(dom.getElementsByClassName('data-to-img')).forEach(ele => {
                let imgSrc = this.$utils.word2Img({
                    fontHeight: fontSizeMap[this.fontsize],
                    fontColor: themeMap[this.theme],
                    lineHeight: 9,
                    word: ele.dataset['source'],
                    fontStyle: `200 ${fontSizeMap[this.fontsize]}px 微软雅黑`
                })
                ele.src = imgSrc
            });
            Array.from(dom.getElementsByTagName(`script`)).forEach(ele => {
                var secScript = document.createElement("script");
                secScript.setAttribute("type", "text/javascript");
                if (ele.src) {
                    secScript.setAttribute("src", ele.src);
                } else {
                    secScript.innerHTML = ele.innerHTML
                }
                document.body.insertBefore(secScript, document.body.lastChild);
            });
            this.$nextTick(() => {
                new this.$utils.ReadCont({
                    dom: this.$refs.articlContent,
                    cb: (a) => {
                        // this.$sendStat(this.stats('readreveal', a)) 
                    }
                })
            })
            return dom.innerHTML
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        this.registerEmitterListener();
    },
    mounted: function () {
        // eslint-disable-next-line
        // window._cmsad({
        //     appendId: 'guangg',
        //     adb_id: '136',
        // })
    },

    watch: {
        propsData: {
            handler() {
                Promise.all([this.$client.getBrowserValue('fontsize'), this.$client.getBrowserDlgSkin()]).then(res => {
                    this.fontsize = res[0] || this.fontsize;
                    this.theme = res[1] == 0 ? 'daily' : 'night'
                })
            },
            immediate: true,
            deep: true,
        },
        fontsizeCache: {
            handler: function(newVal, oldVal) {
                this.fontsize = newVal.fontsize;
            },
            immediate: true,
            deep: true,
        }
    },
    methods: {
        handleArtClick(e) {
            e.preventDefault()
            if (this.judgeClass(e.target, 'client-break')) {
                this.$sendStat(`pc_newschrome_${window.statSeq}.stock`)
                client.switchCode(e.target.dataset['code'].split('|')[0]);
                // client.IsInBrowserDlg().then((msg) => {
                //     if (msg == 'inBrowserDlg') {
                //         client.viewHide()
                //     }
                // })
            } else if (this.judgeClass(e.target, 'client-link')) {
                this.$sendStat(`pc_newschrome_${window.statSeq}.url`)
                window.open(this.judgeClass(e.target, 'client-link').dataset['href'], "_blank");
            }
        },
        judgeClass(el, className) {
            if (!el || !className) return false;
            let element = el
            let flag = false;
            if (element.className == className) {
                flag = element
            } else {
                while (element && !flag) {
                    element = element.parentNode;
                    element ? (flag = (element.className == className ? element : false)) : ''
                }
            }
            return flag;
        },
        registerEmitterListener() {
            this.$on('MESSAGE_TO_CHILD', (params) => {
                if (params.method == 'changeFontSize') {
                    this.fontsize = params.data
                } else if (params.method == 'changeSkin') {
                    this.theme = params.data
                }
            })
        },
    }
}
</script>

<style lang="less">
@import '../../common/style/common-color.less';
#guangg {
    margin-top: 20px;
    a {
        color: #4691ee;
        width: auto !important;
        height:auto !important;
    }
}
.night .content-wrapper .client-break {
    color: #4691ee !important;
    cursor: pointer;
}
.content-wrapper {
    padding-top: 20px;
    padding-left: 1px;
    line-height: 32px;
    * {
        background-color: inherit !important;
    }
    p {
        // font-size: 16px !important;
        line-height: 32px;
        position: relative;
        // color: #eee !important;
        // span{
        // 	color: #eee !important;
        // }
    }
    a {
        color: #4691ee;
        cursor: pointer;
    }
    .client-break {
        color: #4691ee !important;
        cursor: pointer;
    }
    .data-to-img {
        display: inline-block;
        vertical-align: middle;
        line-height: 32px;
    }
    img:not(.data-to-img) {
        width: 95%;
        max-width: 700px;
        display: block;
        margin: 0 auto !important;
    }
    .client-link img {
        width: auto;
    }
    table {
        width: auto !important;
        max-width: 95%;
        border-color: #666;
    }
}
.medium {
    // p{
    font-size: 16px !important;
    // }
}
.large {
    // p{
    font-size: 18px !important;
    // }
}
.night {
    .content-wrapper {
        padding-top: 20px;
        padding-left: 1px;
        line-height: 32px;
        td {
            color: #eee !important;
            border-color: #eee !important;
        }
        table {
            border-color: #a9a9a9;
        }
    }
}
</style>
